import React from "react";

const OFFERS = [
  "Free shipping on orders above ₹1,999",
  "Authentic Ilkal handloom sarees",
  "Premium quality checked before dispatch",
  "Pan India delivery",
  "Cash on Delivery available",
  "Woven in Ilkal, Karnataka",
];

export const OfferMarquee = () => (
  <div className="bg-maroon text-ivory overflow-hidden py-3 border-y border-gold/30" data-testid="offer-marquee">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[...OFFERS, ...OFFERS].map((offer, i) => (
        <span key={i} className="inline-flex items-center text-[11px] sm:text-xs tracking-[0.22em] uppercase">
          <span className="mx-8">{offer}</span>
          <span className="text-gold">•</span>
        </span>
      ))}
    </div>
  </div>
);
